import React, { useState } from "react";
import { useSelector } from "react-redux";
import renderSlotDetails from "../../Auth/Banking/banking";
import Styles from "../../../Styles/Banking/bankingList.module.css";
import { CompanyCheck, TraderList } from "../../../commons/TraderCheck";

const CapacityListingHeader = ({ item, handleCreateDuplicate, listingStatus }) => {
  console.debug("listingStatus", listingStatus)
  const [showDetails, setShowDetails] = useState({});
  const traderList = useSelector(
    (state) => state?.analystReducer?.companyTraders
  )?.[0];
  let activeTrader = TraderList.includes(traderList?.id);
  const role = useSelector((state) => state?.sessionState?.role);
  const currentRoute = window.location.pathname;
  function handleShowDetails(type, index, e) {
    e.stopPropagation();
    setShowDetails((prevState) => ({
      ...prevState,
      [type]: {
        ...prevState[type],
        [index]: !prevState[type]?.[index],
      },
    }));
  }

  return (
    <>
      {role === "BANKING" ? (
        <div className={Styles.bankMainContainer}>
          <div>{item?.name}</div>
          <div className={Styles.topElemContMain}>
            <div className={Styles.eachelemSec}>
              <div>Region</div>
              <div>{item?.company?.region || "NA"}</div>
            </div>
            <div className={Styles.eachelemSec}>
              <div>State</div>
              <div>{item?.company?.state || "NA"}</div>
            </div>
            <div className={Styles.eachelemSec}>
              <div>Credit Rating</div>
              <div>{item?.company?.creditRating || "NA"}</div>
            </div>
            <div className={Styles.eachelemSec}>
              <div>Quantity (MW)</div>
              <div>{item?.requiredQty}</div>
            </div>
            <div className={Styles.eachelemSec}>
              <div>Banking Factor(%)</div>
              <div>{item?.bankingFactor}</div>
            </div>
            <div className={Styles.eachelemSec}>
              <div>Settlement Rate (₹/KWH)</div>
              <div>{item?.settlementRate || "NA"}</div>
            </div>
            <div className={Styles.eachelemSec}>
              <div>Expires On</div>
              <div>{item?.expiryAt}</div>
            </div>
          </div>
          <div className={Styles.topElemContMain2}>
            <div className={Styles.eachelemSec}>
              <div>Injection Range:</div>
              <div>
                {renderSlotDetails(
                  item?.bankingSlotInjects,
                  "injection",
                  item?.id,
                  showDetails
                )}
                {item?.bankingSlotInjects?.length > 1 && (
                  <a
                    className={Styles.linkTextBanking}
                    onClick={(e) => handleShowDetails("injection", item?.id, e)}
                  >
                    {showDetails["injection"]?.[item?.id] ? "less" : "more"}
                  </a>
                )}
              </div>
            </div>
            <div className={Styles.eachelemSec}>
              <div>Drawal Range:</div>
              <div>
                {renderSlotDetails(
                  item?.bankingSlotDrawls,
                  "drawal",
                  item?.id,
                  showDetails
                )}
                {item?.bankingSlotDrawls?.length > 1 && (
                  <a
                    className={Styles.linkTextBanking}
                    onClick={(e) => {
                      handleShowDetails("drawal", item?.id, e);
                    }}
                  >
                    {showDetails["drawal"]?.[item?.id] ? "less" : "more"}
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={Styles.mainCapB_s}>
          <div className="capacity_details_header">
            <div>{item?.name}</div>
            <div className="capacity_details">
              <div className="date-and-time">
                <div>Date : {item?.dateStartAt} </div>
                <div>-</div>
                <div>{item?.dateEndAt} </div>
              </div>
              <div className="date-and-time">
                <div>Time Slot : {item?.slotStartAt} </div>
                <div>-</div>
                <div>
                  {item.slotEndAt &&
                    (item.slotEndAt === "23:59" ? "24:00" : item.slotEndAt)}
                </div>
              </div>
              <div>
                Quantity(MW) :{" "}
                <span>
                  {currentRoute === "/search_listings"
                    ? role === "CONSUMER"
                      ? item?.sellEnergy
                      : item?.purchaseEnergy
                    : role === "GENERATOR"
                      ? item?.sellEnergy
                      : item?.purchaseEnergy}{" "}
                  MW
                </span>
              </div>
              <div>
                {currentRoute === "/search_listings"
                  ? "Energy Rate"
                  : "Energy Rate"}{" "}
                :{" "}
                <span>
                  ₹{" "}
                  {currentRoute === "/search_listings"
                    ? item?.energyRateStr !== ""
                      ? item?.energyRateStr
                      : role === "CONSUMER"
                        ? item?.sellingCost
                        : item?.landingCost
                    : role === "GENERATOR"
                      ? item?.sellingCost
                      : item?.landingCost}
                </span>
              </div>
              {/* <div> Energy Type : <span>{item?.energyType?.type}</span></div> */}
              <div className="small"> Expires on {item?.bidEndAt}</div>
            </div>
          </div>
          {
            listingStatus && (
              <div
                className={
                  TraderList.includes(traderList?.id) &&
                    CompanyCheck?.includes(item?.companyId)
                    ? Styles.connectButton
                    : Styles.connectButton2
                }
                onClick={() => handleCreateDuplicate(item?.id)}
              >
                {TraderList.includes(traderList?.id) &&
                  CompanyCheck?.includes(item?.companyId)
                  ? "Connect"
                  : "Connect"}
              </div>
            )
          }
        </div>
      )}
    </>
  );
};

export default CapacityListingHeader;
